import React from 'react';
import { StyledCard, StyledCardHeader, StyledCardContent, StyledCardFooter } from './Card.styles';

interface CardProps {
  children: React.ReactNode;
  padding?: 'sm' | 'md' | 'lg';
  hover?: boolean;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  padding = 'md',
  hover = false,
  className,
  onClick,
}) => {
  return (
    <StyledCard
      padding={padding}
      hover={hover}
      className={className}
      onClick={onClick}
    >
      {children}
    </StyledCard>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className }) => {
  return <StyledCardHeader className={className}>{children}</StyledCardHeader>;
};

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({ children, className }) => {
  return <StyledCardContent className={className}>{children}</StyledCardContent>;
};

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export const CardFooter: React.FC<CardFooterProps> = ({ children, className }) => {
  return <StyledCardFooter className={className}>{children}</StyledCardFooter>;
};
